import React, { useState } from 'react'
import update from 'immutability-helper'
import TSelectForm from "../../common/TSelectForm"
import TInputForm from "../../common/TInputForm"

const options = [
  {label:'name', value:'html'},
  {label:'property', value:'rdf'},
]

function MetaTagItem(props) {
  const { index, item, onChange, onRemove } = props

  function handleChange(name, value) {
    onChange(index, update(item, {
      [name]: {
        $set: value
      }
    }))
  }

  function handleChangeName(value) {
    handleChange('name', value)
  }

  function handleChangeType(option) {
    handleChange('type', option.value)
  }

  function handleChangeContent(value) {
    handleChange('content', value)
  }

  return (
    <div className='bundle_item'>
      <div className='item_order'>
        <TSelectForm className="opt_set" items={options} selected={item.type} onSelect={handleChangeType} />
        <label className='lab_tf'>
          <TInputForm className='tf_set tf_name' value={item.name} placeholder='이름을 입력하세요' onChange={handleChangeName} />
        </label>
        <label className='lab_tf'>
          <TInputForm className='tf_set tf_content' value={item.content} placeholder='내용을 입력하세요' onChange={handleChangeContent} />
        </label>
        <div className='order_btn'>
          <button type='button' className='btn_post' onClick={e => onRemove(index)}>삭제</button>
        </div>
      </div>
    </div>
  )
}



export default function MetaTagForm(props) {
  const { plugin, data, saveButton, onChange } = props
  const [values, setValues] = useState(data.setting && data.setting.values? JSON.parse(data.setting.values) : [])

  function handleChange(values) {
    setValues(values)
    onChange({
      setting: {
        values: JSON.stringify(values.filter(item => item.name.trim() != '' && item.content.trim() != ''))
      },
      validated: true
    })
  }

  function handleItemChange(index, item) {
    handleChange(update(values, {
      [index]: {
        $set: item
      }
    }))
  }
  function handleRemove(index) {
    handleChange(update(values, {
      $splice: [[index, 1]]
    }))
  }
  function handleAdd() {
    handleChange(update(values, {
      $push: [{name: '', type: 'html', content: ''}]
    }))
  }

  return (
    <div className="desc_plugin50">
      <p className="txt_plugin" dangerouslySetInnerHTML={{ __html: plugin.rawDescription }} />

      <div className="info_plugin set_order">
        {values && values.length > 0 &&
          <div className="list_order">
            {values.map((item, index) =>
              <MetaTagItem
                key={index}
                index={index}
                item={item}
                onChange={handleItemChange}
                onRemove={handleRemove}
              />
            )}
          </div>
        }

        <div className='wrap_add'>
          <label className="lab_btn lab_add">
            <span className="ico_blog ico_add" />
            메타 태그 추가
            <input type="button" className="btn_g" value="링크 추가" onClick={handleAdd} />
          </label>
        </div>
      </div>
      {saveButton()}
    </div>
  )
}
